import request from './request'

export interface LearningTrack {
  date: string
  problem_count: number
  accepted_count: number
  submission_count: number
}

export interface WrongProblem {
  id: number
  problem_id: number
  title: string
  difficulty: string
  tags: string[]
  wrong_count: number
  last_wrong_time: string
}

export interface LearningStats {
  total_problems: number
  accepted_problems: number
  submission_count: number
  acceptance_rate: number
  continuous_days: number
  total_days: number
}

export interface LearningTrackResponse {
  tracks: LearningTrack[]
  stats: LearningStats
}

export interface WrongProblemsResponse {
  list: WrongProblem[]
  total: number
  page: number
  page_size: number
}

// 获取学习轨迹
export function getLearningTrack(params?: { start_date?: string; end_date?: string }) {
  return request.get<LearningTrackResponse>('/learning/track', { params })
}

// 获取错题本
export function getWrongProblems(params?: { page?: number; page_size?: number }) {
  return request.get<WrongProblemsResponse>('/learning/wrong-problems', { params })
}

// 获取学习统计
export function getLearningStats() {
  return request.get<LearningStats>('/learning/stats')
}
